
    const data = {"name":"src/core/icons/view-dashboard-variant-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M2 5v14h20V5H2m18 7h-4V7h4v5m-6-2h-4V7h4v3m-4 2h4v5h-4v-5M4 7h4v10H4V7m12 10v-3h4v3h-4Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            